import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/computer-device-mobile-phone-android-samsung-back.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M176 148a12 12 0 1 1-12-12 12 12 0 0 1 12 12m-84-12a12 12 0 1 0 12 12 12 12 0 0 0-12-12m148 24v24a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-22.87a113.38 113.38 0 0 1 35.4-82.41L26.34 53.66a8 8 0 0 1 11.32-11.32L63.82 68.5a111.43 111.43 0 0 1 128.55-.19l26-26a8 8 0 0 1 11.32 11.32L204.82 78.5c.75.71 1.5 1.43 2.24 2.17A111.25 111.25 0 0 1 240 160m-16 0a96 96 0 0 0-96-96h-.34C74.91 64.18 32 107.75 32 161.13V184h192Z" }, null, -1)])]);
}
var computer_device_mobile_phone_android_samsung_back_default = { render };
//#endregion
export { computer_device_mobile_phone_android_samsung_back_default as default, render };

//# sourceMappingURL=computer-device-mobile-phone-android-samsung-back.svg.js.map